<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.76562 2.125C7.68694 2.125 6.8125 2.99944 6.8125 4.07812C6.8125 5.15681 7.68694 6.03125 8.76562 6.03125H10.7188V10.7188H2.51563C1.43694 10.7188 0.5625 9.84431 0.5625 8.76562V7.98438C0.5625 6.90569 1.43694 6.03125 2.51562 6.03125H5.84201C5.46807 5.47262 5.25 4.80084 5.25 4.07812C5.25 2.1365 6.824 0.5625 8.76562 0.5625C9.87003 0.5625 10.8555 1.07175 11.5 1.86823C12.1445 1.07175 13.13 0.5625 14.2344 0.5625C16.176 0.5625 17.75 2.1365 17.75 4.07812C17.75 4.80084 17.5319 5.47262 17.158 6.03125H21.2656C22.3443 6.03125 23.2188 6.90569 23.2188 7.98438V8.76562C23.2188 9.84431 22.3443 10.7188 21.2656 10.7188H12.2812V6.03125H14.2344C15.3131 6.03125 16.1875 5.15681 16.1875 4.07812C16.1875 2.99944 15.3131 2.125 14.2344 2.125C13.1557 2.125 12.2812 2.99944 12.2812 4.07812V6.03125H10.7188V4.07812C10.7188 2.99944 9.84431 2.125 8.76562 2.125Z"
				:fill="color" 
			/>
			<path d="M10.7188 12.2812H2.125V19.3125C2.125 20.6069 3.17433 21.6562 4.46875 21.6562H10.7188V12.2812Z"
				:fill="color" 
			/>
			<path d="M12.2812 12.2812V21.6562H19.3125C20.6069 21.6562 21.6562 20.6069 21.6562 19.3125V12.2812H12.2812Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgGift',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>